import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
// import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext"; // Store Custom Code
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion, { AccordionProps } from "@insite/mobius/Accordion";
import { AccordionSectionPresentationProps, ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconMemo, IconProps } from "@insite/mobius/Icon";
import File from "@insite/mobius/Icons/File";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
// import { css } from "styled-components"; // Store Custom Code
import { connect, ResolveThunks } from "react-redux";

// Store Custom Code
import { CategoryContext } from "@insite/client-framework/Components/CategoryContext"; // Store Custom Code
import { HasProduct, ProductContext, withProduct } from "@insite/client-framework/Components/ProductContext"; // Store Custom Code
import loadCarouselProducts from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts"; // Store Custom Code
import { getProductsForProductInfoList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors"; // Store Custom Code
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors"; // Store Custom Code
import { BaseTheme } from "@insite/mobius/globals/baseTheme"; // Store Custom Code
import Hidden from "@insite/mobius/Hidden"; // Store Custom Code
import Tab, { TabProps } from "@insite/mobius/Tab"; // Store Custom Code
import TabGroup from "@insite/mobius/TabGroup"; // Store Custom Code
import { breakpointMediaQueries, resolveColor } from "@insite/mobius/utilities"; // Store Custom Code
import getColor from "@insite/mobius/utilities/getColor"; // Store Custom Code
import ExplodedViewsList from "@store/Components/ExplodedView/ExplodedViewsList"; // Store Custom Code
import ProductSubAssemblyItems from "@store/Components/Store/ProductSubAssemblyItems"; // Store Custom Code
import setPdpTabToDiscontinued from "@store/Handlers/SetPdpTabToDiscontinued"; // Store Custom Code
import { StorePdpState } from "@store/Store/Reducers/PdpReducer"; // Store Custom Code
import findIndex from "lodash/findIndex"; // Store Custom Code
import { css, FlattenSimpleInterpolation } from "styled-components"; // Store Custom Code

const enum fields {
    showDocuments = "showDocuments",
    showAttributes = "showAttributes",
    attributesPosition = "attributesPosition",
    documentsPosition = "documentsPosition",
    showEquipmentPartList = "showEquipmentPartList", // Store Custom Code
    equipmentPosition = "equipmentPosition", // Store Custom Code
}

// Store Custom Code - Start
const mapStateToProps = (state: StorePdpState) => ({
    products: getProductsForProductInfoList(state, "subAssemblyItems"),
    triggerDiscontinuedTabNeeded: state.pdpReducer.triggerDiscontinuedTabNeeded,
    evDrawings: getProductsForProductInfoList(state, "evList"), // Store Cystom Code
});

const mapDispatchToProps = {
    loadCarouselProducts,
    setPdpTabToDiscontinued,
};
// Store Custom Code - End

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>; // Store Custom Code

export interface ProductDetailsSpecificationsStyles {
    specificationsAccordion?: AccordionProps;
    specificationsAccordionSection?: AccordionSectionPresentationProps;
    documentsContent?: GridContainerProps; // Store Custom Code
    documentGridItem?: GridItemProps;
    documentLink?: LinkPresentationProps;
    documentIcon?: IconProps;
    documentNameText?: TypographyPresentationProps;
    attributeTypeWrapper?: InjectableCss;
    attributeTypeLabelText?: TypographyPresentationProps;
    attributeTypeValuesText?: TypographyPresentationProps;
    specificationsWrapper?: InjectableCss; // Store Custom Code
    specificationsAttributesWrapper?: InjectableCss; // Store Custom Code
}

export const specificationsStyles: ProductDetailsSpecificationsStyles = {
    specificationsAccordion: {
        headingLevel: 2,
        css: css`
            margin-top: 20px;
        `,
    },
    documentGridItem: {
        width: [12, 12, 6, 6, 6],
    },
    documentIcon: {
        src: File,
        color: "text.link",
        css: css`
            margin-right: 10px;
        `,
    },
    documentNameText: {
        css: css`
            vertical-align: super;
        `,
    },
    attributeTypeLabelText: {
        weight: "bold",
        css: css`
            width: 46%;
            margin-right: 10px;
            text-transform: capitalize;
        `,
    },
    attributeTypeValuesText: {
        css: css`
            width: 50%;
        `,
    },
    attributeTypeWrapper: {
        css: css`
            display: flex;
            padding: 10px 20px;
            font-size: 15px;
            &:nth-child(odd) {
                background: ${getColor("common.accent")};
            }
        `,
    },
    specificationsAttributesWrapper: {
        css: css`
            width: 60%;
            border: 1px solid ${getColor("common.border")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    specificationsWrapper: {
        css: css`
            padding: 20px 0;
        `,
    },
    specificationsAccordionSection: {
        collapseIconProps: {
            color: "text.base",
            src: "ChevronUp",
        },
        expandIconProps: {
            color: "text.base",
            src: "ChevronDown",
        },
        titleTypographyProps: {
            weight: "normal",
            size: 15,
        },
    },
};

const styles = specificationsStyles;

// Store Custom Code - Added a custom list: Equipment
const ProductDetailsSpecifications: React.FC<Props> = ({
    product: { brand, attributeTypes, documents, specifications },
    product,
    fields: {
        showDocuments,
        showAttributes,
        documentsPosition,
        attributesPosition,
        showEquipmentPartList,
        equipmentPosition,
    }, // Store Custom Code
    products, // Store Custom Code
    evDrawings, // Store Custom Code
    loadCarouselProducts, // Store Custom Code
    triggerDiscontinuedTabNeeded, // Store Custom Code
    setPdpTabToDiscontinued, // Store Custom Code
}) => {
    const replacementProductSkus: string = product?.properties?.replacedProductErpNumbers; // Store Custom Code
    const renderingDocuments = showDocuments && documents && documents.length > 0;
    const renderingAttributes = showAttributes && (brand || (attributeTypes && attributeTypes?.length > 0));
    const renderingSpecifications = specifications && specifications.length > 0;
    const renderingEquipmentPartList = showEquipmentPartList && products && products.length > 0; // Store Custom Code
    const renderingExplodedView = evDrawings && evDrawings.length > 0; // Store Custom Code
    const renderingReplacementProducts = product && replacementProductSkus && replacementProductSkus !== ""; // Store Custom Code
    const documentsFirst = documentsPosition === "first";
    const attributesFirst = attributesPosition === "first";
    const equipmentFirst = equipmentPosition === "first";
    const discontinuedProductsKey = "Discontinued products"; // Store Custom Code
    const documentsKey = "Documents"; // Store Custom Code
    const explodedViewKey = "Exploded Views"; // Store Custom Code
    const equipmentKey = "Equipment Part List"; // Store Custom Code
    const attributesKey = "Specifications"; // Store Custom Code
    const tabs: any = [];
    const [productDetailsTabs, setProductDetailsTabs] = React.useState([]);

    const [documentsContent, setDocumentsContent] = React.useState<any>();
    const [attributesAndSpecificationsContent, setAttributesAndSpecificationsContent] = React.useState<any>();
    const [documentsAccordion, setDocumentsAccordion] = React.useState<any>();
    const [attributesAccordion, setAttributesAccordion] = React.useState<any>();
    const [subAssemblyContent, setSubAssemblyContent] = React.useState<any>();
    const [subAssemblyAccordion, setSubAssemblyAccordion] = React.useState<any>();
    const [replacementProductsContent, setReplacementProductsContent] = React.useState<any>();
    const [replacementProductsAccordion, setReplacementProductsAccordion] = React.useState<any>();
    const [explodedViewContent, setExplodedViewContent] = React.useState<any>(); // Store Cystom Code
    const [explodedViewAccordion, setExplodedViewAccordion] = React.useState<any>(); // Store Cystom Code

    const [selectEquipmentPartListTab, setSelectEquipmentPartListTab] = React.useState<boolean>(false);

    const [tabGroupParentRef, setTabGroupParentRef] = React.useState<any>();
    const [accordionParentRef, setAccordionParentRef] = React.useState<any>();

    /* Store Custom Code - Start */
    const [equipmentPartListTabExists, setEquipmentPartListTabExists] = React.useState<boolean>(false);
    const [firstTabKey, setFirstTabKey] = React.useState<string>("");
    /* Store Custom Code - End */

    /* Store Custom Code  - Start */
    const isProductDetailsPage = true;
    const isProductListPage = false;
    const isBrandDetailsPage = false;

    const productContext = React.useContext(ProductContext);
    const brandContext = React.useContext(BrandStateContext).value;
    const category = React.useContext(CategoryContext);

    /* Store Custom Code */
    const goToTabByKey = (tabKey: string, scrollTo = false) => {
        if (tabKey) {
            const indexDiscontinuedProducts = findIndex(productDetailsTabs, { key: tabKey } as any);
            const elDesktop = tabGroupParentRef.querySelector("ul")?.children[indexDiscontinuedProducts];
            const elMobile = accordionParentRef;
            if (elDesktop) {
                elDesktop.dispatchEvent(
                    new MouseEvent("click", {
                        view: window,
                        bubbles: true,
                        cancelable: true,
                        buttons: 1,
                    }),
                );
                if (scrollTo) {
                    tabGroupParentRef?.scrollIntoView({
                        behavior: "smooth",
                    });
                }
            }
            if (elMobile) {
                const accordionTrigger = elMobile.querySelector(`#${tabKey}-trigger`.replace(/\s/g, ""));
                if (accordionTrigger) {
                    if (accordionTrigger.getAttribute("aria-expanded") !== "true") {
                        accordionTrigger.dispatchEvent(
                            new MouseEvent("click", {
                                view: window,
                                bubbles: true,
                                cancelable: true,
                                buttons: 1,
                            }),
                        );
                    }
                    if (scrollTo) {
                        accordionTrigger.scrollIntoView({
                            behavior: "smooth",
                        });
                    }
                }
            }
        }
    };

    if (!renderingDocuments && !renderingAttributes && !renderingSpecifications && !products) {
        // Store Custom Code
        return null;
    }

    /* Store Custom Code  - Start */
    React.useEffect(() => {
        loadCarouselProducts({
            carouselId: "subAssemblyItems",
            carouselType: "relatedProducts",
            relatedProductType: "Sub-assembly",
            seedWithManuallyAssigned: "",
            displayProductsFrom: "allCategories",
            selectedCategoryIds: [],
            numberOfProductsToDisplay: 99,
            isProductDetailsPage,
            productId: productContext?.product?.id,
            isProductListPage,
            category,
            isBrandDetailsPage,
            brand: brandContext,
        });
        loadCarouselProducts({
            carouselId: "evList",
            carouselType: "relatedProducts",
            relatedProductType: "ExplodedViewDrawing",
            seedWithManuallyAssigned: "",
            displayProductsFrom: "allCategories",
            selectedCategoryIds: [],
            numberOfProductsToDisplay: 95,
            isProductDetailsPage: true,
            productId: productContext?.product?.id,
            isProductListPage: false,
            category,
            isBrandDetailsPage: false,
            brand: brandContext,
        });
    }, [productContext?.product?.id]);

    React.useEffect(() => {
        if (triggerDiscontinuedTabNeeded === true) {
            goToTabByKey(discontinuedProductsKey, true);
            setPdpTabToDiscontinued({ triggerDiscontinuedTabNeeded: undefined });
        }
    }, [triggerDiscontinuedTabNeeded]);
    React.useEffect(() => {
        setExplodedViewContent(renderingExplodedView ? <ExplodedViewsList key={explodedViewKey} /> : null);
        setExplodedViewAccordion(
            renderingExplodedView && (
                <ManagedAccordionSection
                    title={translate(explodedViewKey)}
                    uid={explodedViewKey.replace(/\s/g, "")}
                    initialExpanded={
                        equipmentFirst || (!renderingSpecifications && !renderingDocuments && !renderingAttributes)
                    }
                    data-test-selector="productDetails_specifications_attributes"
                    {...styles.specificationsAccordionSection}
                >
                    {explodedViewContent}
                </ManagedAccordionSection>
            ),
        );
    }, [evDrawings]);
    /* Store Custom Code  - End */

    React.useEffect(() => {
        /* Store Custom Code  - Start */
        setDocumentsContent(
            renderingDocuments ? (
                <GridContainer {...styles.documentsContent} key={documentsKey}>
                    {documents!.map(document => (
                        <GridItem key={document.id.toString()} {...styles.documentGridItem}>
                            <Link
                                href={document.filePath}
                                target="_new"
                                {...styles.documentLink}
                                data-test-selector={`productDetails_${document.id}`}
                            >
                                <IconMemo {...styles.documentIcon} />
                                <Typography {...styles.documentNameText}>{document.name}</Typography>
                            </Link>
                        </GridItem>
                    ))}
                </GridContainer>
            ) : null,
        );

        setAttributesAndSpecificationsContent(
            renderingAttributes || renderingSpecifications ? (
                <StyledWrapper {...styles.specificationsAttributesWrapper} key={attributesKey}>
                    {brand && (
                        <StyledWrapper {...styles.attributeTypeWrapper}>
                            <Typography {...styles.attributeTypeLabelText}>{translate("Brand")}&nbsp;</Typography>
                            <Typography {...styles.attributeTypeValuesText}>{brand.name}</Typography>
                        </StyledWrapper>
                    )}
                    {attributeTypes &&
                        attributeTypes.map(attributeType => (
                            <StyledWrapper {...styles.attributeTypeWrapper} key={attributeType.id.toString()}>
                                <Typography {...styles.attributeTypeLabelText}>{attributeType.label}&nbsp;</Typography>
                                <Typography {...styles.attributeTypeValuesText}>
                                    {attributeType
                                        .attributeValues!.map(attributeValue => attributeValue.valueDisplay)
                                        .join(", ")}
                                </Typography>
                            </StyledWrapper>
                        ))}
                    {specifications && (
                        <>
                            {specifications && specifications?.length > 0
                                ? specifications?.map(specification => {
                                      return (
                                          <>
                                              <StyledWrapper {...styles.attributeTypeWrapper}>
                                                  <Typography {...styles.attributeTypeLabelText}>
                                                      {specification.nameDisplay}&nbsp;
                                                  </Typography>
                                                  <Typography {...styles.attributeTypeValuesText}>
                                                      {parse(
                                                          transformContentHtml(specification.htmlContent),
                                                          parserOptions,
                                                      )}
                                                  </Typography>
                                              </StyledWrapper>
                                          </>
                                      );
                                  })
                                : null}
                        </>
                    )}
                </StyledWrapper>
            ) : null,
        );

        /* Store Custom Code  - End */

        setDocumentsAccordion(
            renderingDocuments ? (
                <ManagedAccordionSection
                    title={translate(documentsKey)}
                    uid={documentsKey.replace(/\s/g, "")}
                    data-test-selector="productDetails_specifications_documents"
                    initialExpanded={
                        ((!attributesFirst || !renderingAttributes) && documentsFirst) ||
                        (!renderingSpecifications && !renderingAttributes)
                    }
                    {...styles.specificationsAccordionSection}
                >
                    {documentsContent}
                </ManagedAccordionSection>
            ) : null,
        );

        setAttributesAccordion(
            renderingAttributes && (
                <ManagedAccordionSection
                    title={translate(attributesKey)}
                    uid={attributesKey.replace(/\s/g, "")}
                    initialExpanded={attributesFirst || (!renderingSpecifications && !renderingDocuments)}
                    data-test-selector="productDetails_specifications_attributes"
                    {...styles.specificationsAccordionSection}
                >
                    {attributesAndSpecificationsContent}
                </ManagedAccordionSection>
            ),
        );

        /* Store Custom Code  - Start */
        setSubAssemblyContent(
            renderingEquipmentPartList ? <ProductSubAssemblyItems displayAsTable={true} key={equipmentKey} /> : null,
        );

        setSubAssemblyAccordion(
            renderingEquipmentPartList && (
                <ManagedAccordionSection
                    title={translate(equipmentKey)}
                    uid={equipmentKey.replace(/\s/g, "")}
                    initialExpanded={
                        equipmentFirst || (!renderingSpecifications && !renderingDocuments && !renderingAttributes)
                    }
                    data-test-selector="productDetails_specifications_attributes"
                    {...styles.specificationsAccordionSection}
                >
                    {subAssemblyContent}
                </ManagedAccordionSection>
            ),
        );

        /* Store Custom Code  - Start */
        setReplacementProductsContent(
            renderingReplacementProducts ? (
                <StyledWrapper key={discontinuedProductsKey}>
                    {replacementProductSkus
                        .split(";")
                        .filter(element => {
                            return element !== "";
                        })
                        .map(productSku => (
                            <StyledWrapper key={productSku}>Sku: {productSku}</StyledWrapper>
                        ))}
                </StyledWrapper>
            ) : null,
        );

        setReplacementProductsAccordion(
            renderingReplacementProducts && (
                <ManagedAccordionSection
                    uid={discontinuedProductsKey.replace(/\s/g, "")}
                    title={translate(discontinuedProductsKey)}
                    {...styles.specificationsAccordionSection}
                >
                    {replacementProductsContent}
                </ManagedAccordionSection>
            ),
        );
    }, [products]);

    /* Store Custom Code - Start */
    React.useEffect(() => {
        // Store Custom Code
        const productTabs = [
            attributesAndSpecificationsContent,
            documentsContent,
            subAssemblyContent,
            explodedViewContent,
            replacementProductsContent,
        ];

        productTabs.forEach(productTab => {
            if (productTab) {
                tabs.push(productTab);
                for (const key of Object.keys(productTab)) {
                    if (key === "key" && productTab[key] === equipmentKey) {
                        setEquipmentPartListTabExists(true);
                    }
                }
            }
        });
        if (productTabs[0]) {
            for (const key of Object.keys(productTabs[0])) {
                if (key === "key") {
                    setFirstTabKey(productTabs[0][key]);
                }
            }
        }
        setProductDetailsTabs(tabs);
    }, [attributesAndSpecificationsContent, documentsContent, subAssemblyContent, replacementProductsContent]);
    /* Store Custom Code - End */

    const tabCss: FlattenSimpleInterpolation = css`
        &:hover {
            cursor: pointer;
            border-bottom: 4px solid ${getColor("primary")};
        }
        border-bottom: 4px solid
            ${({ selected, theme }: TabProps) => (selected ? resolveColor("primary", theme!) : "transparent")};
        transition: all 0.4s;
        &:focus {
            outline: none;
        }
        font-weight: ${({ selected }: TabProps) => (selected ? "700" : "normal")};
    ` as FlattenSimpleInterpolation;

    const tabContent = css`
        border-bottom: none;
        padding: 35px;
        overflow-y: auto;
        overflow-x: hidden;
        border: 1px solid ${getColor("common.border")};
    `;

    const tabGroup = css`
        padding: 0;
        margin-top: 20px;
    `;

    const wrapper = css`
        padding: 0;
    `;

    return (
        <>
            {/* Store Custom Code - Start */}
            {productDetailsTabs && productDetailsTabs?.length > 0 ? (
                <Hidden below="md" as="div">
                    <div ref={ref => setTabGroupParentRef(ref)}>
                        <TabGroup cssOverrides={{ tabContent, tabGroup, wrapper }}>
                            {productDetailsTabs?.map((tabItem: any, index: any) => {
                                const tabLabel = translate(tabItem?.key);
                                return (
                                    <Tab css={tabCss} headline={tabLabel} tabKey={`tab${index}`} key={`tab${index}`}>
                                        {tabItem}
                                    </Tab>
                                );
                            })}
                        </TabGroup>
                    </div>
                </Hidden>
            ) : null}
            <Hidden above="sm" as="div">
                <div ref={ref => setAccordionParentRef(ref)}>
                    <Accordion
                        headingLevel={2}
                        data-test-selector="productDetails_specifications"
                        {...styles.specificationsAccordion}
                    >
                        {equipmentFirst && subAssemblyAccordion}
                        {attributesFirst && attributesAccordion}
                        {documentsFirst && documentsAccordion}
                        {!attributesFirst && attributesAccordion}
                        {!equipmentFirst && subAssemblyAccordion}
                        {!documentsFirst && documentsAccordion}
                        {replacementProductsAccordion}
                        {explodedViewAccordion}
                    </Accordion>
                </div>
            </Hidden>
            {/* Store Custom Code - End */}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps, mapDispatchToProps)(ProductDetailsSpecifications)), // Store Custom Code
    definition: {
        displayName: "Specification",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.showDocuments,
                displayName: "Show Documents",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.documentsPosition,
                displayName: "Documents Position",
                editorTemplate: "RadioButtonsField",
                defaultValue: "first",
                horizontal: true,
                fieldType: "General",
                sortOrder: 2,
                options: [
                    {
                        displayName: "Display First",
                        value: "first",
                    },
                    {
                        displayName: "Display Last",
                        value: "last",
                    },
                ],
                isVisible: widget => widget.fields.showDocuments,
            },
            {
                name: fields.showAttributes,
                displayName: "Show Attributes",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 3,
            },
            {
                name: fields.attributesPosition,
                displayName: "Attributes Position",
                editorTemplate: "RadioButtonsField",
                defaultValue: "first",
                horizontal: true,
                fieldType: "General",
                sortOrder: 4,
                options: [
                    {
                        displayName: "Display First",
                        value: "first",
                    },
                    {
                        displayName: "Display Last",
                        value: "last",
                    },
                ],
                isVisible: widget => widget.fields.showAttributes,
            },
            // Store Custom Code
            {
                name: fields.showEquipmentPartList,
                displayName: "Show Equipment Part List",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 4,
            },
            {
                name: fields.equipmentPosition,
                displayName: "Equipment Position",
                editorTemplate: "RadioButtonsField",
                defaultValue: "first",
                fieldType: "General",
                sortOrder: 6,
                options: [
                    {
                        displayName: "Display First",
                        value: "first",
                    },
                    {
                        displayName: "Display Last",
                        value: "last",
                    },
                ],
                isVisible: widget => widget.fields.showEquipmentPartList,
            },
        ],
    },
};

export default widgetModule;
